import { render, staticRenderFns } from "./CourseContentsTemplate18.vue?vue&type=template&id=ed1825ae&"
import script from "./CourseContentsTemplate18.vue?vue&type=script&lang=js&"
export * from "./CourseContentsTemplate18.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports